import { h } from 'vue';
import { RouterLink } from 'vue-router';
import { UserOutlined, CloseSquareOutlined } from '@ant-design/icons-vue';
import { Space } from 'ant-design-vue';

/**
 * Creates an edit button using RouterLink and UserOutlined icon
 * @param {Function} onClick - Click handler function
 * @returns {VNode} Vue render function result
 */
export const createEditButton = onClick => {
  return h(
    RouterLink,
    {
      onClick,
    },
    () => h(UserOutlined),
  );
};

/**
 * Creates a reset password button using RouterLink and CloseSquareOutlined icon
 * @param {Function} onClick - Click handler function
 * @returns {VNode} Vue render function result
 */
export const createResetPasswordButton = onClick => {
  return h(
    RouterLink,
    {
      onClick,
    },
    () => h(CloseSquareOutlined),
  );
};

/**
 * Creates action buttons group with Space component
 * @param {Array} buttons - Array of button VNodes to include in the action group
 * @returns {VNode} Vue render function result with Space component containing buttons
 */
export const createActionGroup = buttons => {
  return h(Space, { size: 'middle' }, () => buttons);
};

/**
 * Creates a complete action group with edit and reset password buttons
 * @param {Object} data - Data object containing user information
 * @param {Function} openRoleModal - Function to open role modal
 * @param {Function} resetPassword - Function to reset password
 * @param {string|number} id - User ID for reset password function
 * @param {string} name - User name for reset password function
 * @returns {VNode} Vue render function result with action buttons
 */
export const createUserActionButtons = (data, { openRoleModal, resetPassword }) => {
  const { id, name } = data;

  const edit = createEditButton(() => openRoleModal(data));
  const resetPasswordBtn = createResetPasswordButton(() => resetPassword(id, name));

  return createActionGroup([edit, resetPasswordBtn]);
};
